var runListeners = function runListeners(store) {
  store.listeners.forEach(function (listener) {
    listener.run(store.state);
  });
};

export { runListeners };